// extracted by mini-css-extract-plugin
export var modal = "_5p-0";